import { ListAllWithPathOutput, uploadData, list } from '@aws-amplify/storage';
import normalize from 'path-normalize';
import { Observable, from, map, switchMap } from 'rxjs';
import { companyConfigService } from '../../../services/companyConfig/companyConfig.service';

class File {
  /**
   * By default upload file to private folder in s3 bucket
   */
  upload(
    key: string,
    file: Parameters<typeof uploadData>[0]['data'],
  ): Observable<{ path: string }> {
    return companyConfigService.getConfigs().pipe(
      switchMap(({ id }) => {
        const task = uploadData({
          path: ({ identityId }) => normalize(`private/${identityId}/${id}/${key}`),
          data: file,
        });
        return from(task.result).pipe(map((result) => ({ path: result.path })));
      }),
    );
  }
  /**
   * By default get list of files from private folder in s3 bucket
   */
  lists(key: string): Observable<ListAllWithPathOutput> {
    return companyConfigService.getConfigs().pipe(
      switchMap(({ id }) => {
        return from(
          list({
            path: ({ identityId }) => normalize(`private/${identityId}/${id}/${key}`),
            options: { listAll: true },
          }),
        );
      }),
    );
  }
}

export const filesHelper = new File();
